import React from 'react';

import { OrderTrackingView } from './tracking.view';
import { useOrderTracking } from './useOrderTracking';

/**
 * `/order-tracking`, the public container.
 *
 * Everything visual lives in `tracking.view.jsx`, which is pure, and everything
 * this route DOES lives in `useOrderTracking`. Both are shared byte for byte
 * with `/admin-order-tracking`; the only things that differ are the `variant`
 * and the mutation key.
 *
 * SECURITY, FLAGGED NOT FIXED
 * ---------------------------
 * `App.js` mounts this route with `ProtectedRoute` COMMENTED OUT, so anyone
 * with a tracking ID can reach it without signing in. The backend agrees:
 * `orders/views.py::track_order` carries `@permission_classes([AllowAny])`.
 * Whether an unauthenticated stranger should be able to resolve a tracking
 * number is a product and security question rather than a design one, so
 * nothing about it is changed here and `App.js` is untouched.
 */
export default function OrderTracking1() {
  const tracking = useOrderTracking({ mutationKey: 'track-order' });
  return <OrderTrackingView variant="public" {...tracking} />;
}
